<template>
  <div style="min-height: 750px;" v-if="d_usrShpcrtBundWdm && d_usrShpcrtBundProWdm && d_usrShpcrtBundProPayWdm && d_userShopWdm">
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8"></b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
    <b-row style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
      <b-col sm="12" md="2" lg="2"> </b-col>
      <b-col sm="12" md="4" lg="4">
        <i class="fa fa-desktop"></i>
        {{ StoreLangTranslation.data['order_list'][StoreLang] }}
      </b-col>
      <b-col sm="12" md="4" lg="4" :style="StoreDevice.isMobile ? '' : 'text-align: right;'"></b-col>
      <b-col sm="12" md="2" lg="2"></b-col>
    </b-row>
    <b-row style="font-size: 16px;">
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8">
        <b-row style="margin: 3px; padding-bottom: 10px;">
          <b-col sm="12" lg="9"></b-col>
          <b-col sm="12" lg="3" style="text-align: right;"></b-col>
        </b-row>
       <b-card no-body>
        <b-card-header header-bg-variant="white" class="p-1">
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="6" style="padding: 2px;">
              <strong> {{ StoreLangTranslation.data['order_list'][StoreLang] }} </strong>
            </b-col>
            <b-col sm="12" lg="6" style="text-align: right;"></b-col>
          </b-row>
        </b-card-header>
          <template v-if="d_loading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
          <template v-else>
            <b-row>
              <b-col sm="12" lg="12">
                <!-- 
                  d_shopOrderList = [
                    {
                      "product_list": [],
                      "user_shopcart_bundle_data": {},
                      "user_shop_bundle_data": {},
                    }
                  ]
                 -->
                <b-card no-body v-for="(shop_item, shop_item_index) in d_shopOrderList">
                  <b-card-header header-bg-variant="white" class="p-1">
                     <b-row style="margin: 0px; background-color: #93ffe4; padding: 5px;">
                      <b-col sm="12" lg="4">
                          <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['2'] && shop_item.shop_data.data['0']['2']['lang'] && shop_item.shop_data.data['0']['2']['lang'][StoreLang]">
                            <img :src="shop_item.shop_data.data['0']['2']['lang'][StoreLang]" style="width: 30px; margin-right: 3px;">
                          </template>
                          <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['2'] && shop_item.shop_data.data['0']['2']['val']">
                            <img :src="shop_item.shop_data.data['0']['2']['val']" style="width: 30px; margin-right: 3px;">
                          </template>
                          <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['1'] && shop_item.shop_data.data['0']['1']['lang'] && shop_item.shop_data.data['0']['1']['lang'][StoreLang]">
                            <strong :title="shop_item.shop_data.data['0']['1']['lang'][StoreLang]">{{ shop_item.shop_data.data['0']['1']['lang'][StoreLang].length > 30 ? shop_item.shop_data.data['0']['1']['lang'][StoreLang].substring(0,15) + '...' : shop_item.shop_data.data['0']['1']['lang'][StoreLang] }}</strong>
                          </template>
                          <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['1'] && shop_item.shop_data.data['0']['1']['val']">
                            <strong :title="shop_item.shop_data.data['0']['1']['val']">{{ shop_item.shop_data.data['0']['1']['val'].length > 30 ? shop_item.shop_data.data['0']['1']['val'].substring(0,15) + '...' : shop_item.shop_data.data['0']['1']['val'] }}</strong>
                          </template>
                      </b-col>
                      <b-col sm="12" lg="3">
                        <i class="fa fa-envelope"></i>
                          <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['29'] && shop_item.shop_data.data['0']['29']['lang'] && shop_item.shop_data.data['0']['29']['lang'][StoreLang]">
                            <strong>{{ shop_item.shop_data.data['0']['29']['lang'][StoreLang] }}</strong>
                          </template>
                          <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['29'] && shop_item.shop_data.data['0']['29']['val']">
                            <strong>{{ shop_item.shop_data.data['0']['29']['val'] }}</strong>
                          </template>
                      </b-col>
                      <b-col sm="12" lg="3">
                        <i class="fa fa-mobile-phone"></i>
                          <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['30'] && shop_item.shop_data.data['0']['30']['lang'] && shop_item.shop_data.data['0']['30']['lang'][StoreLang]">
                            <strong>{{ shop_item.shop_data.data['0']['30']['lang'][StoreLang] }}</strong>
                          </template>
                          <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['30'] && shop_item.shop_data.data['0']['30']['val']">
                            <strong>{{ shop_item.shop_data.data['0']['30']['val'] }}</strong>
                          </template>
                      </b-col>
                    </b-row>
                  </b-card-header>
                  <b-card-body>
                    <b-card>
                      <b-card-header header-bg-variant="white" class="p-1">
                        <b-row style="margin: 3px;">
                          <b-col sm="12" lg="6" style="padding: 2px;">
                            <strong>
                              {{ StoreLangTranslation.data['pay_with_money_transfer'][StoreLang] }}
                            </strong>
                          </b-col>
                          <b-col sm="12" lg="6" style="text-align: right;"></b-col>
                        </b-row>
                      </b-card-header>

                   <!--    <b-card-header header-bg-variant="white" class="p-1">
                        <b-row style="margin: 0px; background-color: #93ffe4; padding: 5px;">
                          <b-col sm="12" lg="4">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['2'] && shop_item.shop_data.data['0']['2']['lang'] && shop_item.shop_data.data['0']['2']['lang'][StoreLang]">
                                <img :src="shop_item.shop_data.data['0']['2']['lang'][StoreLang]" style="width: 30px; margin-right: 3px;">
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['2'] && shop_item.shop_data.data['0']['2']['val']">
                                <img :src="shop_item.shop_data.data['0']['2']['val']" style="width: 30px; margin-right: 3px;">
                              </template>
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['1'] && shop_item.shop_data.data['0']['1']['lang'] && shop_item.shop_data.data['0']['1']['lang'][StoreLang]">
                                <strong :title="shop_item.shop_data.data['0']['1']['lang'][StoreLang]">{{ shop_item.shop_data.data['0']['1']['lang'][StoreLang].length > 30 ? shop_item.shop_data.data['0']['1']['lang'][StoreLang].substring(0,15) + '...' : shop_item.shop_data.data['0']['1']['lang'][StoreLang] }}</strong>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['1'] && shop_item.shop_data.data['0']['1']['val']">
                                <strong :title="shop_item.shop_data.data['0']['1']['val']">{{ shop_item.shop_data.data['0']['1']['val'].length > 30 ? shop_item.shop_data.data['0']['1']['val'].substring(0,15) + '...' : shop_item.shop_data.data['0']['1']['val'] }}</strong>
                              </template>
                          </b-col>
                          <b-col sm="12" lg="4">
                            <i class="fa fa-envelope" style="margin: 3px;"></i>
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['29'] && shop_item.shop_data.data['0']['29']['lang'] && shop_item.shop_data.data['0']['29']['lang'][StoreLang]">
                                <strong>{{ shop_item.shop_data.data['0']['29']['lang'][StoreLang] }}</strong>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['29'] && shop_item.shop_data.data['0']['29']['val']">
                                <strong>{{ shop_item.shop_data.data['0']['29']['val'] }}</strong>
                              </template>
                          </b-col>
                          <b-col sm="12" lg="4">
                            <i class="fa fa-mobile-phone" style="margin: 3px;"></i>
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['30'] && shop_item.shop_data.data['0']['30']['lang'] && shop_item.shop_data.data['0']['30']['lang'][StoreLang]">
                                <strong>{{ shop_item.shop_data.data['0']['30']['lang'][StoreLang] }}</strong>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['30'] && shop_item.shop_data.data['0']['30']['val']">
                                <strong>{{ shop_item.shop_data.data['0']['30']['val'] }}</strong>
                              </template>
                          </b-col>
                        </b-row>
                      </b-card-header>
 -->
                        <b-card v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['9'] && shop_item.shop_data.data['0']['9']['lang'] && shop_item.shop_data.data['0']['9']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['9'] && shop_item.shop_data.data['0']['9']['val'])">
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['9'] && shop_item.shop_data.data['0']['9']['lang'] && shop_item.shop_data.data['0']['9']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['9'] && shop_item.shop_data.data['0']['9']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['9']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['9'] && shop_item.shop_data.data['0']['9']['lang'] && shop_item.shop_data.data['0']['9']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['9']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['9'] && shop_item.shop_data.data['0']['9']['val']">
                                <span>{{ shop_item.shop_data.data['0']['9']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['10'] && shop_item.shop_data.data['0']['10']['lang'] && shop_item.shop_data.data['0']['10']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['10'] && shop_item.shop_data.data['0']['10']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['10']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['10'] && shop_item.shop_data.data['0']['10']['lang'] && shop_item.shop_data.data['0']['10']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['10']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['10'] && shop_item.shop_data.data['0']['10']['val']">
                                <span>{{ shop_item.shop_data.data['0']['10']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['11'] && shop_item.shop_data.data['0']['11']['lang'] && shop_item.shop_data.data['0']['11']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['11'] && shop_item.shop_data.data['0']['11']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['11']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['11'] && shop_item.shop_data.data['0']['11']['lang'] && shop_item.shop_data.data['0']['11']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['11']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['11'] && shop_item.shop_data.data['0']['11']['val']">
                                <span>{{ shop_item.shop_data.data['0']['11']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['12'] && shop_item.shop_data.data['0']['12']['lang'] && shop_item.shop_data.data['0']['12']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['12'] && shop_item.shop_data.data['0']['12']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['12']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['12'] && shop_item.shop_data.data['0']['12']['lang'] && shop_item.shop_data.data['0']['12']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['12']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['12'] && shop_item.shop_data.data['0']['12']['val']">
                                <span>{{ shop_item.shop_data.data['0']['12']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                        </b-card>

                        <div style="height: 10px"></div>

                        <b-card v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['13'] && shop_item.shop_data.data['0']['13']['lang'] && shop_item.shop_data.data['0']['13']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['13'] && shop_item.shop_data.data['0']['13']['val'])">
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['13'] && shop_item.shop_data.data['0']['13']['lang'] && shop_item.shop_data.data['0']['13']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['13'] && shop_item.shop_data.data['0']['13']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['13']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['13'] && shop_item.shop_data.data['0']['13']['lang'] && shop_item.shop_data.data['0']['13']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['13']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['13'] && shop_item.shop_data.data['0']['13']['val']">
                                <span>{{ shop_item.shop_data.data['0']['13']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['14'] && shop_item.shop_data.data['0']['14']['lang'] && shop_item.shop_data.data['0']['14']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['14'] && shop_item.shop_data.data['0']['14']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['14']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['14'] && shop_item.shop_data.data['0']['14']['lang'] && shop_item.shop_data.data['0']['14']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['14']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['14'] && shop_item.shop_data.data['0']['14']['val']">
                                <span>{{ shop_item.shop_data.data['0']['14']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['15'] && shop_item.shop_data.data['0']['15']['lang'] && shop_item.shop_data.data['0']['15']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['15'] && shop_item.shop_data.data['0']['15']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['15']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['15'] && shop_item.shop_data.data['0']['15']['lang'] && shop_item.shop_data.data['0']['15']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['15']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['15'] && shop_item.shop_data.data['0']['15']['val']">
                                <span>{{ shop_item.shop_data.data['0']['15']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['16'] && shop_item.shop_data.data['0']['16']['lang'] && shop_item.shop_data.data['0']['16']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['16'] && shop_item.shop_data.data['0']['16']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['16']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['16'] && shop_item.shop_data.data['0']['16']['lang'] && shop_item.shop_data.data['0']['16']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['16']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['16'] && shop_item.shop_data.data['0']['16']['val']">
                                <span>{{ shop_item.shop_data.data['0']['16']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                        </b-card>

                        <div style="height: 10px"></div>

                        <b-card v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['17'] && shop_item.shop_data.data['0']['17']['lang'] && shop_item.shop_data.data['0']['17']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['17'] && shop_item.shop_data.data['0']['17']['val'])">
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['17'] && shop_item.shop_data.data['0']['17']['lang'] && shop_item.shop_data.data['0']['17']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['17'] && shop_item.shop_data.data['0']['17']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['17']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['17'] && shop_item.shop_data.data['0']['17']['lang'] && shop_item.shop_data.data['0']['17']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['17']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['17'] && shop_item.shop_data.data['0']['17']['val']">
                                <span>{{ shop_item.shop_data.data['0']['17']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['18'] && shop_item.shop_data.data['0']['18']['lang'] && shop_item.shop_data.data['0']['18']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['18'] && shop_item.shop_data.data['0']['18']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['18']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['18'] && shop_item.shop_data.data['0']['18']['lang'] && shop_item.shop_data.data['0']['18']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['18']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['18'] && shop_item.shop_data.data['0']['18']['val']">
                                <span>{{ shop_item.shop_data.data['0']['18']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['19'] && shop_item.shop_data.data['0']['19']['lang'] && shop_item.shop_data.data['0']['19']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['19'] && shop_item.shop_data.data['0']['19']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['19']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['19'] && shop_item.shop_data.data['0']['19']['lang'] && shop_item.shop_data.data['0']['19']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['19']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['19'] && shop_item.shop_data.data['0']['19']['val']">
                                <span>{{ shop_item.shop_data.data['0']['19']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['20'] && shop_item.shop_data.data['0']['20']['lang'] && shop_item.shop_data.data['0']['20']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['20'] && shop_item.shop_data.data['0']['20']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['20']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['20'] && shop_item.shop_data.data['0']['20']['lang'] && shop_item.shop_data.data['0']['20']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['20']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['20'] && shop_item.shop_data.data['0']['20']['val']">
                                <span>{{ shop_item.shop_data.data['0']['20']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                        </b-card>

                        <div style="height: 10px"></div>

                        <b-card v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['21'] && shop_item.shop_data.data['0']['21']['lang'] && shop_item.shop_data.data['0']['21']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['21'] && shop_item.shop_data.data['0']['21']['val'])">
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['21'] && shop_item.shop_data.data['0']['21']['lang'] && shop_item.shop_data.data['0']['21']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['21'] && shop_item.shop_data.data['0']['21']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['21']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['21'] && shop_item.shop_data.data['0']['21']['lang'] && shop_item.shop_data.data['0']['21']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['21']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['21'] && shop_item.shop_data.data['0']['21']['val']">
                                <span>{{ shop_item.shop_data.data['0']['21']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['22'] && shop_item.shop_data.data['0']['22']['lang'] && shop_item.shop_data.data['0']['22']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['22'] && shop_item.shop_data.data['0']['22']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['22']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['22'] && shop_item.shop_data.data['0']['22']['lang'] && shop_item.shop_data.data['0']['22']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['22']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['22'] && shop_item.shop_data.data['0']['22']['val']">
                                <span>{{ shop_item.shop_data.data['0']['22']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['23'] && shop_item.shop_data.data['0']['23']['lang'] && shop_item.shop_data.data['0']['23']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['23'] && shop_item.shop_data.data['0']['23']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['23']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['23'] && shop_item.shop_data.data['0']['23']['lang'] && shop_item.shop_data.data['0']['23']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['23']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['23'] && shop_item.shop_data.data['0']['23']['val']">
                                <span>{{ shop_item.shop_data.data['0']['23']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['24'] && shop_item.shop_data.data['0']['24']['lang'] && shop_item.shop_data.data['0']['24']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['24'] && shop_item.shop_data.data['0']['24']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['24']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['24'] && shop_item.shop_data.data['0']['24']['lang'] && shop_item.shop_data.data['0']['24']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['24']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['24'] && shop_item.shop_data.data['0']['24']['val']">
                                <span>{{ shop_item.shop_data.data['0']['24']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                        </b-card>

                        <div style="height: 10px"></div>

                        <b-card v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['25'] && shop_item.shop_data.data['0']['25']['lang'] && shop_item.shop_data.data['0']['25']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['25'] && shop_item.shop_data.data['0']['25']['val'])">
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['25'] && shop_item.shop_data.data['0']['25']['lang'] && shop_item.shop_data.data['0']['25']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['25'] && shop_item.shop_data.data['0']['25']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['25']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['25'] && shop_item.shop_data.data['0']['25']['lang'] && shop_item.shop_data.data['0']['25']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['25']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['25'] && shop_item.shop_data.data['0']['25']['val']">
                                <span>{{ shop_item.shop_data.data['0']['25']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['26'] && shop_item.shop_data.data['0']['26']['lang'] && shop_item.shop_data.data['0']['26']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['26'] && shop_item.shop_data.data['0']['26']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['26']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['26'] && shop_item.shop_data.data['0']['26']['lang'] && shop_item.shop_data.data['0']['26']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['26']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['26'] && shop_item.shop_data.data['0']['26']['val']">
                                <span>{{ shop_item.shop_data.data['0']['26']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['27'] && shop_item.shop_data.data['0']['27']['lang'] && shop_item.shop_data.data['0']['27']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['27'] && shop_item.shop_data.data['0']['27']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['27']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['27'] && shop_item.shop_data.data['0']['27']['lang'] && shop_item.shop_data.data['0']['27']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['27']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['27'] && shop_item.shop_data.data['0']['27']['val']">
                                <span>{{ shop_item.shop_data.data['0']['27']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                          <b-row v-if="(shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['28'] && shop_item.shop_data.data['0']['28']['lang'] && shop_item.shop_data.data['0']['28']['lang'][StoreLang]) || (shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['28'] && shop_item.shop_data.data['0']['28']['val'])">
                            <b-col sm="12" lg="3">
                              {{ d_userShopWdm['0']['parameters']['28']['name']['translation'][StoreLang] }}
                            </b-col>
                            <b-col sm="12" lg="9">
                              <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['28'] && shop_item.shop_data.data['0']['28']['lang'] && shop_item.shop_data.data['0']['28']['lang'][StoreLang]">
                                <span>{{ shop_item.shop_data.data['0']['28']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['28'] && shop_item.shop_data.data['0']['28']['val']">
                                <span>{{ shop_item.shop_data.data['0']['28']['val'] }}</span>
                              </template>
                            </b-col>
                          </b-row>
                        </b-card>
                    </b-card>

                    <template v-for="(bundle_item, bundle_item_index) in shop_item.bundle_list" v-if="f_searchUserShopBundle(bundle_item)">
                       <b-row @mouseover="d_hoverIndex = bundle_item_index" @mouseleave="d_hoverIndex = ''" :style="StoreDevice.isMobile ? 'cursor: pointer; border-bottom: solid 1px #dcdcdc; font-weight: 900; background: #f7e48f;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc; font-weight: 900; background: #f7e48f;'">
                        <b-col sm="12" lg="6">
                          <template v-if="bundle_item.user_shop_bundle_data.data && bundle_item.user_shop_bundle_data.data['0'] && bundle_item.user_shop_bundle_data.data['0']['1'] && bundle_item.user_shop_bundle_data.data['0']['1']['lang'] && bundle_item.user_shop_bundle_data.data['0']['1']['lang'][StoreLang]">
                            <span :style="d_hoverIndex === bundle_item_index ? ' color: rgb(252, 0, 153, 1);' : ''">{{ bundle_item.user_shop_bundle_data.data['0']['1']['lang'][StoreLang] }}</span>
                          </template>
                          <template v-else-if="bundle_item.user_shop_bundle_data.data && bundle_item.user_shop_bundle_data.data['0'] && bundle_item.user_shop_bundle_data.data['0']['1'] && bundle_item.user_shop_bundle_data.data['0']['1']['val']">
                            <span :style="d_hoverIndex === bundle_item_index ? ' color: rgb(252, 0, 153, 1);' : ''">{{ bundle_item.user_shop_bundle_data.data['0']['1']['val'] }}</span>
                          </template>
                        </b-col>
                        <b-col sm="12" lg="2">
                          {{ f_calculateProductTotalPrice(bundle_item.product_list) }}
                        </b-col>
                        <b-col sm="12" lg="2">
                            <template v-if="bundle_item.user_shopcart_bundle_data.data['0']['0'] && bundle_item.user_shopcart_bundle_data.data['0']['0']['val'] && bundle_item.user_shopcart_bundle_data.data['0']['0']['val']['value']">
                              {{ f_getOptionLabel(bundle_item.user_shopcart_bundle_data.data['0']['0']['val']['value'], d_usrShpcrtBundWdm['0']['parameters']['0']['options']) }}
                            </template>
                        </b-col>
                        <b-col sm="12" lg="2">
                          <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                            <template slot="button-content">
                              {{ StoreLangTranslation.data['process'][StoreLang] }}
                            </template>
                            <b-dropdown-item @click="f_cancelUserShopcartBundle(bundle_item.user_shopcart_bundle_data, shop_item.shop_data.cl)"><i class="fa fa-trash"></i> {{ StoreLangTranslation.data['cancel'][StoreLang] }} </b-dropdown-item>
                          </b-dropdown>
                        </b-col>
                      </b-row>
                      <template v-for="(product_item, product_item_index) in bundle_item.product_list" v-if="f_showCheckProduct(product_item.product)">
                        <b-row :style="StoreDevice.isMobile ? 'cursor: pointer; border-bottom: solid 1px #dcdcdc; margin-left: 10px;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc; margin-left: 10px;'">
                          <b-col sm="12" lg="8">
                            <i @click="f_openProductIngredients(product_item.product)" style="border-radius: 10px; padding-right: 5px; margin: 3px; padding-left: 5px; width: 20px; background-color: lightblue; text-align: center;">{{ (product_item_index + 1).toString() }}</i>
                            <template v-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['1'] && product_item.product.data['0']['1']['lang'] && product_item.product.data['0']['1']['lang'][StoreLang]">
                              <span>{{ product_item.product.data['0']['1']['lang'][StoreLang] }}</span>
                            </template>
                            <template v-else-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['1'] && product_item.product.data['0']['1']['val']">
                              <span>{{ product_item.product.data['0']['1']['val'] }}</span>
                            </template>
                          </b-col>
                          <b-col sm="12" lg="2"> {{ f_calculateProductTotalPrice([product_item]) }} </b-col>
                          <b-col sm="12" lg="2">
                            <template v-if="product_item.product.data['0']['0'] && product_item.product.data['0']['0']['val'] && product_item.product.data['0']['0']['val']['value']">
                                  {{ f_getOptionLabel(product_item.product.data['0']['0']['val']['value'], d_usrShpcrtBundProWdm['0']['parameters']['0']['options']) }}
                              </template>
                          </b-col>
                        </b-row>
                        <template v-for="(payment_item, payment_index) in product_item.payment_list">
                            <b-row :style="StoreDevice.isMobile ? 'cursor: pointer; border-bottom: solid 1px #dcdcdc; margin-left: 30px; font-size: 12px;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc; margin-left: 30px; font-size: 12px;'">
                            <b-col sm="12" lg="1" style="padding: 2px; text-align: right;">
                              <i @click="f_openProductPaymentIngredients(payment_item)" style="border-radius: 10px; padding-right: 5px; margin: 3px; padding-left: 5px; width: 20px; background-color: #ade6ad; text-align: center;">{{ (payment_index + 1).toString() }}</i>
                            </b-col>
                            <b-col sm="12" lg="1" style="padding: 2px;">
                              <template v-if="payment_item.data['0']['1'] && payment_item.data['0']['1']['val'] && payment_item.data['0']['1']['val']['value']">
                                {{ f_getOptionLabel(payment_item.data['0']['1']['val']['value'], d_usrShpcrtBundProPayWdm['0']['parameters']['1']['options']) }}
                              </template>
                            </b-col>
                            <b-col sm="12" lg="2" style="padding: 2px;">
                              <template v-if="payment_item.data['0']['2'] && payment_item.data['0']['2']['val'] && payment_item.data['0']['2']['val']['value']">
                                {{ f_getOptionLabel(payment_item.data['0']['2']['val']['value'], d_usrShpcrtBundProPayWdm['0']['parameters']['2']['options']) }}
                              </template>
                            </b-col>
                            <b-col sm="12" lg="1" style="padding: 2px;">
                              <template v-if="payment_item.data['0']['4'] && payment_item.data['0']['4']['val']  && payment_item.data['0'][22] && payment_item.data['0']['4']['val']">
                                {{ payment_item.data['0']['4']['val'] *( payment_item.data['0']['22']['val'] / 100) }}
                              </template> 
                              <template v-else>
                                {{ payment_item.data['0']['4']['val'] }}
                              </template>
                              <template v-if="payment_item.data['0']['3'] && payment_item.data['0']['3']['val'] && payment_item.data['0']['3']['val']['value']">
                                {{ f_getOptionLabel(payment_item.data['0']['3']['val']['value'], d_usrShpcrtBundProPayWdm['0']['parameters']['3']['options']) }}
                              </template>
                            </b-col>
                            <b-col sm="12" lg="2">
                              <template v-if="payment_item.data['0']['17'] && payment_item.data['0']['17']['val']">
                                {{ payment_item.data['0']['17']['val'] }}
                              </template>
                            </b-col>
                            <b-col sm="12" lg="2">
                              <template v-if="payment_item.data['0']['0'] && payment_item.data['0']['0']['val'] && payment_item.data['0']['0']['val']['value']">
                                <span style="font-size: 12px;"> {{ f_getOptionLabel(payment_item.data['0']['0']['val']['value'], d_usrShpcrtBundProPayWdm['0']['parameters']['0']['options']) }} </span>
                              </template>
                            </b-col>
                          </b-row>
                        </template>
                      </template>
                      <div style="margin-bottom: 10px">
                        <b-row style="margin: 3px;">
                          <b-col sm="12" lg="6">
                            <span v-if="d_bundleDocLoading == bundle_item.user_shopcart_bundle_data.client_id">
                              <b-spinner variant="primary" style="margin: 2px;"></b-spinner>
                            </span>
                            <span v-else-if="bundle_item.user_shopcart_bundle_data.data['0']['35'] && bundle_item.user_shopcart_bundle_data.data['0']['35']['val']" style="color: blue; cursor: pointer;" @click="f_startBundleDocumentDownload(bundle_item.user_shopcart_bundle_data.client_id)">
                              {{ StoreLangTranslation.data['download_receipt_document'][StoreLang] }}
                            </span>
                            <span v-else style="color: red">
                              {{ StoreLangTranslation.data['no_receipt_document'][StoreLang] }}
                            </span>
                          </b-col>
                          <b-col sm="12" lg="6">
                            <b-form-file
                              v-model="d_tmpFile"
                              :accept="f_createAcceptedDocumentTypes()"
                              @input="f_addFileToDocuments(bundle_item.user_shopcart_bundle_data.parent_c.id, bundle_item.user_shopcart_bundle_data.client_id, bundle_item)"
                              :browse-text="StoreLangTranslation.data['select_file'][StoreLang]"
                              :placeholder="StoreLangTranslation.data['select_receipt_file'][StoreLang]"
                              style="margin-bottom: 5px;"
                              :disabled="d_bundleDocLoading == bundle_item.user_shopcart_bundle_data.client_id"
                            ></b-form-file>
                          </b-col>
                        </b-row>
                      </div>
                    </template>
                  </b-card-body>
                 </b-card>
              </b-col>
            </b-row>
          </template>
      </b-card>

      </b-col>
      <b-col sm="12" lg="8"></b-col>
    </b-row>
    <b-modal v-if="d_selectedProductData.show" id="d_selectedProductData_show" v-model="d_selectedProductData.show" scrollable hide-footer :title="StoreLangTranslation.data['product_ingredients'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="lg">
      <p>
        <b-row>
          <b-col sm="12" lg="12">
            <shopcard-bundle-product-show :p_productData="d_selectedProductData.data"></shopcard-bundle-product-show>
          </b-col>
        </b-row>
      </p>
      <p>
      <b-row>
          <b-col sm="12" lg="6"></b-col>
          <b-col sm="12" lg="6" style="text-align: right;">
          </b-col>
        </b-row>
      </p>
    </b-modal>
    <b-modal v-if="d_selectedProductPaymentData.show" id="d_selectedProductPaymentData_show" v-model="d_selectedProductPaymentData.show" scrollable hide-footer :title="StoreLangTranslation.data['payment_details'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="lg">
      <p>
        <b-row>
          <b-col sm="12" lg="12">
            <shopcard-bundle-product-payment-show :p_paymentData="d_selectedProductPaymentData.data"></shopcard-bundle-product-payment-show>
          </b-col>
        </b-row>
      </p>
      <p>
      <b-row>
          <b-col sm="12" lg="6"></b-col>
          <b-col sm="12" lg="6" style="text-align: right;">
          </b-col>
        </b-row>
      </p>
    </b-modal>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as PageInfo
} from '@/components/widgets/PageInfo';
import {
  default as ShopcardBundleProductShow
} from '@/components/widgets/ShopcardBundleProductShow';
import {
  default as ShopcardBundleProductPaymentShow
} from '@/components/widgets/ShopcardBundleProductPaymentShow';
import { mapGetters } from 'vuex';
export default {
  name: 'user_shopcart_bundle_order_list',
  computed: mapGetters({
    StoreLang: 'StoreLang',
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
    StoreShopCartOrderList: 'StoreShopCartOrderList',
    StoreCurrencyType: 'StoreCurrencyType',
  }),
  components: {
    PageInfo,
    ShopcardBundleProductShow,
    ShopcardBundleProductPaymentShow,
  },
  props: {},
  data () {
    return {
      d_loading: false,
      d_selectedProductListForPayment: {
        'user_shopcart_bundle_client_id': '',
        'product_list': [],
        'show': false
      },
      d_selectedProductPaymentData: {
        'data': '',
        'show': false
      },
      d_selectedProductData: {
        'data': '',
        'show': false
      },
      d_paymentModal: {
        'data': '',
        'show': false
      },
      d_usrShpcrtBundWdm: '',
      d_userShopWdm: '',
      d_usrShpcrtBundProWdm: '',
      d_usrShpcrtBundProPayWdm: '',
      d_currencyType: '0', // 0 tl, 1 dollar
      d_user: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_frontendClientID: '',
      d_frontendList: [],
      d_usrShpBundleList: [],
      d_shopOrderList: [],
      d_tmpFile: null,
      d_bundleDocLoading: '',
      d_exchange_data: {},
    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr_shp').then(resp_wdm_data => { this.d_userShopWdm = resp_wdm_data; });
    ClsWdm.getLayerWdm('usr_shpcrt_bund').then(resp_wdm_data => { this.d_usrShpcrtBundWdm = resp_wdm_data; });
    ClsWdm.getLayerWdm('usr_shpcrt_bund_pro').then(resp_wdm_data => { this.d_usrShpcrtBundProWdm = resp_wdm_data; });
    ClsWdm.getLayerWdm('usr_shpcrt_bund_pro_pay').then(resp_wdm_data => { this.d_usrShpcrtBundProPayWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    this.d_userShopClientID = this.$route.query.user_shop_client_id;
    if (this.d_user && this.d_user.username) {
      this.f_userShopCartBundleOrderList();
    }
  },
  beforeMount () {},
  mounted: function () {
    // console.log(this.StoreFrontendSettings);
    // console.log(this.d_usrShpBundWdm);
    this.d_shopOrderList = this.StoreShopCartOrderList.data;

  },
  methods: {
    f_startBundleDocumentDownload: function (user_shopcart_bundle_client_id) {
      let query = 'user_client_id=' + this.d_user.username;
      query += '&user_shopcart_bundle_client_id=' + user_shopcart_bundle_client_id;
      let data = {};
      ServiceFunctions.user_shopcart_bundle_document_get(query, data)
        .then(resp => {
          if (resp.data.doc && resp.data.doc_extension) {
            let file_name = 'receipt.' + resp.data.doc_extension;
            this.f_downloadDocument(resp.data.doc, file_name)
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_downloadDocument: function (base64_file, base64_file_name) {
      // console.log("base64_file ", base64_file);
      // console.log("base64_file_name ", base64_file_name);
      function base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
        }
        return bytes;
      }

      var saveByteArray = (function () {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        return function (data, name) {
          var blob = new Blob(data, { type: "octet/stream" }),
            url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = name;
          a.click();
          window.URL.revokeObjectURL(url);
        };
      }());
      var sampleBytes = base64ToArrayBuffer(base64_file);
      saveByteArray([sampleBytes], base64_file_name);
    },

    f_addFileToDocuments: function (user_shopcart_client_id, user_shopcart_bundle_client_id, bundle_item) {
      if (this.d_tmpFile) {
        // console.log(this.d_tmpFile);
        let file_name = this.d_tmpFile.name;
        let arr = this.d_tmpFile.name.split('.');
        let fileExtension = arr[arr.length - 1];
        if (["jpg", "jpeg", "png", "ico", "pdf", "html", "htm", "doc", "docx"].indexOf(fileExtension.toLowerCase()) === -1) {
          this.d_tmpFile = null;
          this.$forceUpdate();
          alert(this.StoreLangTranslation.data['file_extension_type_is_not_eligible'][this.StoreLang]);
          return;
        }
        if (this.d_tmpFile.size > 10485760) {
          this.d_tmpFile = null;
          this.$forceUpdate();
          alert(this.StoreLangTranslation.data['file_size_is_not_eligible'][this.StoreLang], ' : ', this.d_tmpFile.size);
          return;
        }
        var reader = new FileReader();
        var vm = this;
        var reader = new FileReader();
        reader.addEventListener("load", function () {
          // console.log(reader.result);
          // console.log('page_info_index ', page_info_index);
          // console.log('page_info_detail_index ', page_info_detail_index);
          // console.log('vm.d_frdWebunitData.page_info ', vm.d_frdWebunitData.page_info);
          // console.log('reader.result; ', reader.result);
          vm.f_documentRecord(reader.result, fileExtension, user_shopcart_client_id, user_shopcart_bundle_client_id, bundle_item);
          vm.$forceUpdate();
        }, false);
        reader.readAsDataURL(this.d_tmpFile);
        this.d_tmpFile = null;
        this.$forceUpdate();

      }
    },
    f_createAcceptedDocumentTypes: function () {
      let accept = '';
      let file_types = ["jpg", "jpeg", "png", "ico", "pdf", "html", "htm", "doc", "docx"];
      for (let i in file_types) {
        accept += '.' + file_types[i] + ',';
      }
      return accept;
    },
    f_documentRecord: function (file_data, file_type, user_shopcart_client_id, user_shopcart_bundle_client_id, bundle_item) {
      this.d_bundleDocLoading = user_shopcart_bundle_client_id;
      let query = 'user_client_id=' + this.d_user.username;
      query += '&user_shopcart_client_id=' + user_shopcart_client_id;
      query += '&user_shopcart_bundle_client_id=' + user_shopcart_bundle_client_id;
      let data = {
        'file': file_data,
        'file_type': file_type
      };
      ServiceFunctions.user_shopcart_bundle_document_record(query, data)
        .then(resp_record => {
          this.d_bundleDocLoading = '';
          if (resp_record.data.status_code.substring(resp_record.data.status_code.length - 3, resp_record.data.status_code.length) == '000') {
            if (resp_record.data.doc_record == '1' || resp_record.data.bundle_doc_record == '1') {
              alert('başarılı');
              bundle_item.user_shopcart_bundle_data.data['0']['35'] = {'val': resp_record.data.doc_id}
            } else {
              alert('Dosya yüklenirken hatayla karşılaşıldı. Lütfen tekrar deneyin veya destek ile iletişime geçin.');
            }

          } else {
            let txt = 'status_code = ' + resp_record.data.status_code + '\n';
            txt += 'status_message = ' + resp_record.data.status_message;
            alert(txt);
          }
        });
    },
    f_showCheckProduct: function (product_data) {
      let show_product = true;
      try {
        if (product_data.data['0']['48']['val']['value'] === '0') {
          show_product = false;
        }
      } catch(err) {}
      return show_product;
    },
    f_cancelUserShopcartBundle: function (user_shopcart_bundle_data, user_shop_client_id) {
      let query = 'user_client_id=' + this.d_user.username;
      query += '&user_shopcart_bundle_client_id=' + user_shopcart_bundle_data.client_id;
      query += '&user_shop_client_id=' + user_shop_client_id;
      let data = {};
      ServiceFunctions.user_shopcart_bundle_cancel(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.cancel_status === 'completed') {
              this.f_userShopCartBundleOrderList();
              alert(this.StoreLangTranslation.data['cancel_completed'][this.StoreLang]);
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_userShopCartBundleOrderList: function () {
      this.d_loading = true;
      let query = 'user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_shopcart_bundle_order_list(query, data)
        .then(resp => {
          this.d_loading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_shopOrderList = resp.data.list;
            this.d_exchange_data = resp.data.exchange_data;
            if (this.StoreShopCartOrderList.status === 1) {
              this.$store.commit('MutationShopCartOrderList', { 'status': 0, 'data': this.StoreShopCartOrderList.data });
            } else {
              this.$store.commit('MutationShopCartOrderList', { 'status': 1, 'data': this.StoreShopCartOrderList.data });
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_userShopCartBundleActiveList: function () {
      let query = 'user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_shopcart_bundle_active_list(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_shopOrderList = resp.data.list;
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_getEligibleBundleProductPaymentStatus: function (pay_data) {
      let pay_last_status = '';
      let pay_option_list = [];
      try {
        pay_last_status = pay_data.data['0']['0']['val']['value'];
      } catch(err) {}
      for (let option_index in this.d_usrShpcrtBundProPayWdm['0']['parameters']['0']['options']) {
        if (pay_last_status !== this.d_usrShpcrtBundProPayWdm['0']['parameters']['0']['options'][option_index].value) {
          pay_option_list.push(this.d_usrShpcrtBundProPayWdm['0']['parameters']['0']['options'][option_index]);
        }
      }
      return pay_option_list;
    },
    f_getOptionLabel: function (option_value, options) {
      //console.log('option_value : ', option_value);
      //console.log('options : ', options);
      let option_label = '';
      for (let i in options) {
        if (options[i].value === option_value) {
          option_label = options[i].translation[this.StoreLang];
          break;
        }
      }
      return option_label;
    },
    f_openPaymentScreen: function (product_list, user_shopcart_bundle_client_id) {
      this.d_selectedProductListForPayment.product_list = product_list;
      this.d_selectedProductListForPayment.user_shopcart_bundle_client_id = user_shopcart_bundle_client_id;
      this.d_selectedProductListForPayment.show = true;
    },
    f_openProductIngredients: function (product_data) {
      this.d_selectedProductData.show = true;
      this.d_selectedProductData.data = product_data;
    },
    f_openProductPaymentIngredients: function (payment_data) {
      this.d_selectedProductPaymentData.show = true;
      this.d_selectedProductPaymentData.data = payment_data;
    },
    f_searchUserShopBundle: function (usr_shp_bund) {
      let res = false;
      if (this.d_searchText) {
        if (usr_shp_bund.w_id.toLocaleLowerCase().indexOf(this.d_searchText.toLocaleLowerCase()) !== -1) {
          res = true;
        }
      } else {
        res = true;
      }
      return res;
    },
    f_calculateProductTotalPrice: function (bundle_products) {
      let currency_text = this.StoreCurrencyType.label;
      let total_amount = 0;
      let exchange_amount = 1;
      let tl_price = null;
      let non_tl_price = null;
      let product_cur_type = null;
      let cur_fixed = true;
      for (let product_index in bundle_products) {
        tl_price = null;
        non_tl_price = null;
        try {//currency_list
          for (let currency_amount_index in bundle_products[product_index].product.data['0']['25'].list) {
            let currency_amount_item = bundle_products[product_index].product.data['0']['25'].list[currency_amount_index];
            product_cur_type = bundle_products[product_index].product.data['0']['25'].list[currency_amount_index]['26']['val']['value'];
            let exchange_cur_type = this.d_exchange_data['system'][product_cur_type];
            let page_cur_type = this.d_exchange_data['system'][this.StoreCurrencyType.value];
            if (page_cur_type != null){
              if (exchange_cur_type != null){
                if(this.d_exchange_data[page_cur_type] != null){
                  exchange_amount = parseFloat(this.d_exchange_data[page_cur_type][exchange_cur_type]);
                }
              }
            }
            if(currency_amount_item['64'] && currency_amount_item['64']['val'] && currency_amount_item['64']['val']['value'] &&currency_amount_item['64']['val']['value'] === '1'){
              cur_fixed = false;
            }
            else{
              cur_fixed = true;
            }
            //Gelen ürünün para birimine göre atama
            if(product_cur_type === '0'){ 
              tl_price = parseFloat(currency_amount_item['27']['val']);
            }
            else{
              non_tl_price = parseFloat(currency_amount_item['27']['val']);
            }
            }
            try {
              if (cur_fixed){//Kur sabit/fixed
                  if (this.StoreCurrencyType.value ==='0' && tl_price !== null) {
                    total_amount += tl_price;
                  }
                  else if (this.StoreCurrencyType.value ==='1' && non_tl_price !== null){
                    total_amount += non_tl_price;
                  }
                  else{
                    total_amount += (non_tl_price * exchange_amount) + (tl_price * exchange_amount);
                  }
                }
                else{//Kur değeri Güncel
    
                  if(this.StoreCurrencyType.value ==='0'){
                    //Sayfa para birimi tl ise
                    if(tl_price !== null){
                      total_amount += tl_price;
                    }
                    else{
                      total_amount += non_tl_price * exchange_amount;
                    }
                  }
                  else{
                    //sayfa para birimide dolar ise
                    if(non_tl_price !== null){
                      total_amount += non_tl_price;
                    }
                    else{
                      total_amount += tl_price * exchange_amount;
                    }
                  }
                }  
            } catch(err) {}
          
        } catch(err) {}
      }
      return total_amount.toFixed(2) + ' ' + currency_text; 
    },
    f_calculateProductTotalPriceWithDiscount: function (bundle_products, user_shopcart_bundle_client_id) {
      let max_discount_percent = 0;
      if (this.d_bundleDiscounts && this.d_bundleDiscounts[user_shopcart_bundle_client_id]) {
        max_discount_percent = this.d_bundleDiscounts[user_shopcart_bundle_client_id]['max_discount_percent'];
      }
      let currency_text = this.StoreCurrencyType.label;
      let total_amount = 0;
      total_amount = parseFloat(this.f_calculateProductTotalPrice(bundle_products));
      total_amount = total_amount * ((100 - max_discount_percent) / 100);
      return total_amount + ' ' + currency_text;
    },
  },
  watch: {}
};

</script>

